import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { TranslateService } from '@ngx-translate/core';
import { AlertService } from '@shared/src/services/alert/alert.service';
import { LoadingService } from '@shared/src/services/loading/loading.service';
import { Router } from '@angular/router';
import { BaseSubMaintenanceController } from '../../_base/BaseSubMaintenanceController';
import { PanelPermissionGroupItemMaintenanceDto } from './PanelPermissionGroupItemMaintenanceDto';
import { PanelPermissionGroupListMaintenanceDto } from './PanelPermissionGroupListMaintenanceDto';

@Injectable()
export class PanelPermissionGroupSubMaintenanceController extends BaseSubMaintenanceController<PanelPermissionGroupListMaintenanceDto, PanelPermissionGroupItemMaintenanceDto> {

    constructor(
        protected http: HttpClient,
        @Inject('AlertService') protected alertService: AlertService,
        protected translateService: TranslateService,
        @Inject('LoadingService') protected loadingService: LoadingService,
        protected router: Router) {

        super(http, alertService, translateService, loadingService, router, "panel/permissiongroup");
    }

    public getResourceRoot(): string {
        return "PANEL.PERMISSION.GROUP";
    }

    public buildUrl(parentId: number, optionParentid: string, uri: string): string {
        return "/system/screensandforms/panelsetting/" + parentId + "/" + optionParentid + "/submain" + uri;
    }
}